/**
 * Shared class-id generator for the collection color-filter editors
 * (SimpleEditor/MatrixEditor). A monotonically increasing sequence, namespaced
 * by a caller-supplied prefix (e.g. `'class'`/`'mclass'`) so ids stay
 * distinguishable by editor type in exported/saved filter configs, while both
 * editors draw from the same counter instead of each keeping its own — a
 * matrix and a simple filter edited in the same session can't collide.
 */
let seq = 0;

/**
 * @param {string} prefix - id namespace, e.g. `'class'` or `'mclass'`
 * @returns {string} a unique id, e.g. `class_1699999999999_3`
 */
export const createClassId = prefix => `${prefix}_${Date.now()}_${seq++}`;

export default createClassId;
